const U = "https://images.unsplash.com/";
const q = (w, h) => `?auto=format&fit=crop&w=${w}&h=${h}&q=80`;

export const IMAGES = {
  hero: `${U}photo-1516937941344-00b4e0337589${q(1200, 900)}`,
  why: `${U}photo-1581093450021-4a7360e9a6b5${q(900, 1100)}`,
  sectorLithium: `${U}photo-1523848309072-c199db53f137${q(800, 600)}`,
  sectorOil: `${U}photo-1611273426858-450d8e3c9fce${q(800, 600)}`,
  sectorInfra: `${U}photo-1473341304170-971dccb5ac1e${q(800, 600)}`,
  transparency: `${U}photo-1551288049-bebda4e38f71${q(1000, 750)}`,
  data: `${U}photo-1460925895917-afdab827c52f${q(1000, 700)}`,
  regionPuna: `${U}photo-1496247749665-49cf5b1022e9${q(800, 600)}`,
  regionNeuquen: `${U}photo-1504307651254-35680f356dfd${q(800, 600)}`,
  regionBuenosAires: `${U}photo-1486406146926-c627a92ad1ab${q(800, 600)}`,
  reports: `${U}photo-1554224155-6726b3ff858f${q(900, 700)}`,
};

export default IMAGES;
